import { ChatMessage, KurentoResponse, Unread } from '_helpers';

function subscribeToOnlineEvents(dispatch: any) {
    return (
      [
          {
              key: 'unread',
              method: (unread: { [key: string]: Unread }) => {
                  dispatch.online.setUnread(unread);
              },
          },
          {
              key: 'presentedApplicants',
              method: (applicantIds: string[]) => {
                  dispatch.online.setAcceptedApplications(applicantIds);
              },
          },
          {
              key: 'chatMessage',
              method: (chatMessage: ChatMessage) => {
                  dispatch.online.handleNewMessageAsync(chatMessage);
              },
          },
          {
              key: 'chatMessages',
              method: (chatMessages: ChatMessage[]) => {
                  dispatch.online.setMessages(chatMessages);
              },
          },
          {
              key: 'kurentoMessage',
              method: (response: KurentoResponse) => {
                  dispatch.online.handleKurentoMessage(response);
              },
          },
      ]
    );
}

export default subscribeToOnlineEvents;
